module.exports = __webpack_public_path__ + "img/about-background.fe13c07f.jpg";